module.exports = __webpack_public_path__ + "static/media/paint.2df0a70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/paint.png
// module id = 37
// module chunks = 0